document.addEventListener('DOMContentLoaded', function () {
    const modal = document.querySelector('.servicehulkForm');
    const modalContent = document.querySelector('.service-modal-content');
    const openBtns = document.querySelectorAll('.serviceopenForm');
    const closeBtns = document.querySelectorAll('.servicecloseForm .serviceclose');

    function openModal() {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    }

    // Attach open event to all open buttons
    openBtns.forEach(btn => {
        btn.addEventListener('click', openModal);
    });

    // Attach close event to all close buttons
    closeBtns.forEach(btn => {
        btn.addEventListener('click', closeModal);
    });

    // Close modal when clicking outside the modal content
    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.style.display === 'block') {
            closeModal();
        }
    });
});

window.addEventListener('message', function(event) {
    if (event.data && event.data.type === "CLOSE_HULK_FORM") {
        console.log("Received CLOSE_HULK_FORM message");

        const modal = document.querySelector('.servicehulkForm');
        if (modal) {
            modal.style.display = 'none';
            document.body.style.overflow = 'auto';
        } else {
            console.warn("Modal .hulkForm not found");
        }
    }
});